<template>
  <div>
    <public-header title="订单详情" show-back></public-header>
    <a-spin :spinning="loading">
      <div class="full-width bg-white border-radius-12 p-24 points-order-detail" style="color: #363B45" >
        <tk-flex middle wrap :gutter="8"  >
          <div class="p-r-8 font-bold font-20">订单号：{{ pageData.number }}</div>
          <div class="p-x-8 p-y-4" :style="{borderRadius: '6px', border: `1px solid ${currentStatus.color}`, color: currentStatus.color}" >{{ currentStatus.title }}</div>
        </tk-flex>
        <!-- 基本信息 -->
        <div>
          <div class="font-14 font-bold m-t-24 m-b-20" >基本信息</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" v-if="pageData && pageData.objectId" >
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              门店：{{ pageData.store.fullName }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              下单用户：{{ pageData.user.nickName }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              手机号：{{ pageData.user.phone }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.logisticsCompany"  >
              物流公司：{{ pageData.logisticsCompany }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.logisticsNumber" >
              物流单号：{{ pageData.logisticsNumber }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              创建时间：{{ pageData.createdAt | date }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>
        <!--地址 -->
        <div>
          <div class="font-14 font-bold m-t-24 m-b-20" >收货地址</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" >
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              联系人：{{ pageData.shippingAddressData.name }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              联系电话：{{ pageData.shippingAddressData.phone }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" style="word-break: break-all;" >
              地址：{{ pageData.shippingAddressData.regionCoder + pageData.shippingAddressData.address }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>
        <!-- 订单详情 -->
        <div style="width: 100%;overflow: hidden;">
          <div class="font-14 font-bold m-t-24 m-b-20" >订单详情</div>
          <a-table
          v-if="device !== 'mobile'"
            style="width: 100%" :columns="columns" :data-source="data" :pagination="false" :scroll="{x: 600}" size="small">
            <div slot="image" slot-scope="text">
              <viewer v-if="text" :images="text">
                <img v-for="(t,i) in text" :key="i" :src="t" style="width: 60px;height:60px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" :style="{'display': i===0?'':'none'}" />
              </viewer>
              <span v-else> 暂无 </span>
            </div>
            <template slot="footer"  >
              <div :style="{textAlign: device === 'mobile' ? 'left' : 'right'}">
                共计1个商品，
                商品积分：{{ pageData.pointsAmount || 0 }}
              </div>
            </template>
          </a-table>
          <div v-else>
            <a-descriptions bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
              <a-descriptions-item
                v-for="( itm, i) in columns" :key="`item${i}`"
                :label="itm.title"
              >
                <div v-if="itm.dataIndex === 'image'">
                  <viewer v-if="item[itm.dataIndex]" :images="item[itm.dataIndex]">
                    <img v-for="(t,i) in item[itm.dataIndex]" :key="i" :src="t" style="width: 60px;height:60px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" :style="{'display': i===0?'':'none'}" />
                  </viewer>
                  <span v-else> 暂无 </span>
                </div>
                <div v-else>
                  {{item[itm.dataIndex]}}
                </div>
              </a-descriptions-item>
            </a-descriptions>
            <div :style="{textAlign: device === 'mobile' ? 'left' : 'right'}">
              共计1个商品，
              商品积分：{{ pageData.pointsAmount || 0 }}
            </div>
          </div>
        </div>
        <!-- 物流信息 -->
        <div class="full-width" v-if="pageData.status === '1' || pageData.status === '2'">
          <div class="font-14 font-bold m-t-24 m-b-20">物流信息</div>
          <!--主体内容 -->
          <div :style="{width: `calc(100% / ${ device !== 'mobile' ? 3 : 1})`}">
            <!-- 通过数组长度判断显示内容 >0显示物流信息-->
            <div class="full-width" v-if="dataList.length">
                <div class="full-width" v-for="(item,index) in dataList" :key="index">
                  <!-- 右边内容 -->
                  <div
                    class="content"
                    :style="{'border-left-width': index === dataList.length - 1 ? '0' : '1px'}"
                  >
                      <div
                        class="left"
                        v-if="index == 0">
                        <div class="leftContent"></div>
                      </div>
                      <div v-else class="border" :style="{left: `${ index != dataList.length -1 ? '-4px' : '-3px'}`}"></div>
                      <div
                        style="font-size:13px;position: relative;word-break: break-all;"
                        :style="{top:`${index === 0 ? '-8px' : '-5pX'}`, color: index === 0 ? '#202224' : '#8A92A1'}"
                      >{{pageData.type === '0' ? item.context : item.AcceptStation}}</div>
                      <div  style="font-size:13px;color: #8A92A1">{{pageData.type === '0' ? item.ftime : item.AcceptTime}}</div>
                  </div>
                </div>
              </div>
              <div class="font-14 font-bold m-b-20" v-else>暂无物流信息</div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import publicHeader from '../../components/publicHeader.vue'

export default {
  components: {
    publicHeader
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      columns: [
        {
          title: '商品名称',
          dataIndex: 'name',
          key: 'name',
          width: 150
        },
        {
          title: '图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '积分',
          key: 'point',
          dataIndex: 'point',
          width: 100
        }
      ],
      data: [
        {
          image: '',
          name: '',
          number: '1',
          point: ''
        }
      ],
      currentStatus: {},
      dataList: [] // 物流信息
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化菜单按钮
    async init () {
      try {
        const { data } = await this.$tkParse.get(`/classes/pointsOrder/${this.$route.query.id}`, {
          params: { include: 'store,user,shippingAddress,selfLogisticsCompany' }
        })
        if (data.type === '0') {
          data.logisticsCompany = data.selfLogisticsCompany ? data.selfLogisticsCompany.name : null
        }
        console.log(data)
        this.setStatus(data.status)
        this.data[0].image = data.pointsProductData.images
        this.data[0].name = data.pointsProductData.name
        this.data[0].point = data.pointsProductData.points
        // 如果data的长度大于1
        if (this.data.length > 1) {
          this.data.splice(1, 1)
        }
        this.pageData = data
        await this.getLogistics()
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async getLogistics () {
      try {
        let orderId = this.$route.query.id
        if (this.pageData.type === '1') {
          let { data: order } = await this.$tkParse.post(`/damaicheng/getOrderDetail`, {
            order_sn: orderId
          })
          if (order.info && order.info.orderinfo && order.info.orderinfo.shipping) {
            this.dataList = [...order.info.orderinfo.shipping]
          }
          console.log(order)
        } else {
          let { data: res } = await this.$tkParse.post(`/delivery/getLogistics`, {
            id: orderId
          })
          this.dataList = [...res.data]
          console.log(res)
        }
      } catch (error) {
        console.log(error)
      }
    },
    setStatus (status) {
      switch (status) {
        case '0':
          this.currentStatus = {
            title: '未发货',
            color: '#FF9F0E'
          }
          break
        case '1':
          this.currentStatus = {
            title: '已发货',
            color: '#2F82FF'
          }
          break
        case '2':
          this.currentStatus = {
            title: '已完成',
            color: '#808690'
          }
          break
        case 'cancel':
          this.currentStatus = {
            title: '已取消',
            color: '#A9AFB9'
          }
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.points-order-detail{
  .content {
    padding-left: 15px;
    border-width: 0;
    border-style: solid;
    border-color: #BEC3CD;
    padding-bottom: 28px;
    position: relative;
    .left{
      width: 17px;
      height: 17px;
      border-radius: 50%;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      left: -9px;
      background-color: rgba(255,42,88,0.1);
      top:-8px;
    }
    .leftContent {
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: #FF2A58;
    }
    .border{
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #BEC3CD;
      position: absolute;
      top: 0;
    }
  }
}
</style>
